<template>
<div class="investor-article">
    <h2>
        <router-link :to="{name:'investor-article-view',params:{slug:article.slug}}">{{article.title}}</router-link>
    </h2>
    <span>{{ article.created | date }}</span>
</div>
</template>

<script>
import {
    mapGetters
} from 'vuex';

export default {

    name: "InvestorArticleResult",

    props: {
        article: {}
    },

    computed: {

        ...mapGetters(['user'])
    }
}
</script>
